import { SpartenType } from '@ps20/bff-models';

export const THH_HUND_UEBERSICHT_TITLE = 'Hundehalter-Haftpflichtversicherung';
export const THH_PFERD_UEBERSICHT_TITLE = 'Pferdehalter-Haftpflichtversicherung';
export const UNFALL_TITLE = 'Unfallversicherung';
export const GEGE_TITLE = 'Gegenstandsschutz';

export enum App {
  PH = 'ph-angebot',
  VHV = 'vhv-angebot',
  VHV_V2 = 'vhv-angebot-v2',
  RS = 'rs-angebot',
  RS_VERMIETUNG = 'rs-vermietung-angebot',
  VWG = 'vwg-angebot',
  VWG_V2 = 'vwg-angebot-v2',
  UNF = 'unf-angebot',
  THH_HUND = 'thh-hund-angebot',
  THH_PFERD = 'thh-pferd-angebot',
  TKV = 'tkv-angebot',
  UNF_ZS = 'unf-angebot-zaehlstueck',
  SHOP = 'shop',
  SHOP_DASHBOARD = 'ps20-shop-dashboard-gui',
  SHOP_CHECKOUT = 'shop-checkout',
  SHOP_TOOLBAR = 'shop-toolbar',
  GEGE = 'gege-angebot',
  JHP = 'jhp-angebot',
  TKV_V2 = 'tkv-angebot-v2',
  TGV = 'tgv-angebot',
}

export enum AppSubroute {
  TAA_ANGEBOT = '/angebot',
  TAA_EINGABE = '/eingabe',
  SHOP_CHECKOUT_DANKE = '/danke',
}

export function getAppEnumByAppName(appName: string): App {
  const appKey = Object.keys(App).find(key => (App as Record<string, App>)[key] === appName);
  return (App as Record<string, App>)[appKey];
}

export function getAppEnumBySpartenType(spartenType: SpartenType): App {
  switch (spartenType) {
    case SpartenType.HAUSRAT:
      return App.VHV;
    case SpartenType.HAUSRAT_V2:
      return App.VHV_V2;
    case SpartenType.PRIVATHAFTPFLICHT:
      return App.PH;
    case SpartenType.RECHTSSCHUTZ:
      return App.RS;
    case SpartenType.RECHTSSCHUTZ_VERMIETUNG:
      return App.RS_VERMIETUNG;
    case SpartenType.WOHNGEBAEUDE:
      return App.VWG;
    case SpartenType.WOHNGEBAEUDE_V2:
      return App.VWG_V2;
    case SpartenType.TIERHALTERHAFTPFLICHT_HUND:
      return App.THH_HUND;
    case SpartenType.TIERHALTERHAFTPFLICHT_PFERD:
      return App.THH_PFERD;
    case SpartenType.TIERKRANKEN:
      return App.TKV;
    case SpartenType.TIERKRANKEN_V2:
      return App.TKV_V2;
    case SpartenType.UNFALL:
      return App.UNF;
    case SpartenType.JAGDHAFTPFLICHT:
      return App.JHP;
    case SpartenType.GEGENSTANDSSCHUTZ:
      return App.GEGE;
    default:
      return null;
  }
}
export function getSpartenTypeByApp(app: App): SpartenType {
  return ({
    [App.VWG]: SpartenType.WOHNGEBAEUDE,
    [App.VWG_V2]: SpartenType.WOHNGEBAEUDE_V2,
    [App.VHV]: SpartenType.HAUSRAT,
    [App.VHV_V2]: SpartenType.HAUSRAT_V2,
    [App.PH]: SpartenType.PRIVATHAFTPFLICHT,
    [App.RS]: SpartenType.RECHTSSCHUTZ,
    [App.RS_VERMIETUNG]: SpartenType.RECHTSSCHUTZ_VERMIETUNG,
    [App.THH_HUND]: SpartenType.TIERHALTERHAFTPFLICHT_HUND,
    [App.THH_PFERD]: SpartenType.TIERHALTERHAFTPFLICHT_PFERD,
    [App.TKV]: SpartenType.TIERKRANKEN,
    [App.UNF]: SpartenType.UNFALL,
    [App.JHP]: SpartenType.JAGDHAFTPFLICHT,
    [App.GEGE]: SpartenType.GEGENSTANDSSCHUTZ,
    [App.TKV_V2]: SpartenType.TIERKRANKEN_V2,
  } as Partial<Record<App, SpartenType>>)[app];
}

export function getAppTitle(app: App): string {
  return ({
    [App.VWG]: 'Wohngebäudeversicherung',
    [App.VWG_V2]: 'Wohngebäudeversicherung',
    [App.VHV]: 'Hausratversicherung',
    [App.VHV_V2]: 'Hausratversicherung',
    [App.PH]: 'Privat-Haftpflichtversicherung',
    [App.RS]: 'Rechtsschutzversicherung',
    [App.RS_VERMIETUNG]: 'Rechtsschutzversicherung Vermietung',
    [App.THH_HUND]: 'Tierhalter-Haftpflichtversicherung (Hund)',
    [App.THH_PFERD]: 'Tierhalter-Haftpflichtversicherung (Pferd)',
    [App.TKV]: 'Tierkrankenversicherung',
    [App.UNF]: 'Unfallversicherung',
    [App.JHP]: 'Jagd-Haftpflichtversicherung',
    [App.UNF_ZS]: 'Unfallversicherung Zählstück',
    [App.GEGE]: 'Gegenstandsschutz',
    [App.TKV_V2]: 'Tierkrankenversicherung',
    [App.TGV]: 'Tiergruppenversicherung',
  } as Partial<Record<App, string>>)[app];
}

export function getAnzeigenamen(app: App): string {
  return ({
    [App.VWG]: 'Wohngebäudeversicherung',
    [App.VWG_V2]: 'Wohngebäudeversicherung',
    [App.VHV]: 'Hausrat',
    [App.VHV_V2]: 'Hausrat',
    [App.PH]: 'Privathaftpflicht',
    [App.RS]: 'Rechtsschutz',
    [App.RS_VERMIETUNG]: 'Rechtsschutz - Vermietung',
    [App.THH_HUND]: 'Tierhalterhaftpflicht (Hund)',
    [App.THH_PFERD]: 'Tierhalterhaftpflicht (Pferd)',
    [App.TKV]: 'Tierkrankenversicherung',
    [App.UNF]: 'Unfallversicherung',
    [App.JHP]: 'Jagd-Haftpflichtversicherung',
    [App.UNF_ZS]: 'Unfall Zählstück',
    [App.GEGE]: 'Gegenstandschutz',
    [App.TKV_V2]: 'Tierkrankenversicherung',
    [App.TGV]: 'Tiergruppenversicherung',
  } as Partial<Record<App, string>>)[app];
}

export const isAppAllowedForJuristischePerson = (app: App): boolean =>
  [App.VHV, App.VHV_V2, App.VWG, App.VWG_V2, App.TKV, App.TKV_V2, App.TGV].includes(app);

export const isMultistoreApp = (appId: App): boolean =>
  [App.VWG, App.VWG_V2, App.TKV, App.VHV, App.VHV_V2, App.UNF, App.GEGE, App.TKV_V2].includes(appId);

export const isVwgV2 = (appId: App): boolean => appId === App.VWG_V2;

export const isVhvV2 = (appId: App): boolean => appId === App.VHV_V2;

export const isHausratSparte = (spartenType: SpartenType): boolean =>
  spartenType === SpartenType.HAUSRAT || spartenType === SpartenType.HAUSRAT_V2;
